<template>
  <div class="o-input">
    <div class="o-input__label"></div>
    <div class="o-input__controls">
      <div class="c-shopping-list">
        <div class="c-shopping-list__row c-shopping-list__total" v-show="showSubTotal && discount > 0">
          <div class="c-shopping-list__description">Subtotaal</div>
          <div class="c-shopping-list__price">{{ formatCurrency(subTotal) }} euro</div>
        </div>
        <div class="c-shopping-list__row c-shopping-list__total" v-show="discount > 0">
          <div class="c-shopping-list__description">Korting</div>
          <div class="c-shopping-list__price">-{{ formatCurrency(discount) }} euro</div>
        </div>
        <div class="c-shopping-list__row c-shopping-list__total">
          <div class="c-shopping-list__description">
            <div>Totaal</div>
            <div v-show="showZeroOrderWarning" class="has-warning">
              Bestelling moet meer dan 0,00 euro bedragen.
            </div>
          </div>
          <div class="c-shopping-list__price">{{ formatCurrency(totalCost) }} euro</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { useStore } from "vuex";
import { computed } from "vue";
import { formatCurrency } from "@/infrastructure/utilities";

export default {
  props: {
    showSubTotal: { type: Boolean, default: true },
    showZeroOrderWarning: { type: Boolean, default: false },
  },
  setup() {
    const store = useStore();
    const subTotal = computed(() => store.getters["orders/totalCost"]);
    const totalCost = computed(() => store.getters["orders/totalCostWithDiscount"]);
    const discount = computed(() => store.state.webshop.discount || 0);

    return {
      subTotal,
      discount,
      totalCost,
      formatCurrency,
    };
  },
};
</script>
